import { QueryClient } from "@tanstack/react-query";
import { SessionMethodName, SessionMethodParams, SessionQueryDataForMethod } from "../../types";
import { buildSessionQueryKey } from "../../keys";

export interface GetSessionQueryDataArgs<Method extends SessionMethodName> {
  method: Method;
  request: Partial<SessionMethodParams<Method>>;
  queryClient: QueryClient;
}

export const getSessionQueryData = <Method extends SessionMethodName>({
  method,
  request,
  queryClient,
}: GetSessionQueryDataArgs<Method>): SessionQueryDataForMethod<Method> | undefined => {
  const queryKey = buildSessionQueryKey({ method, request });
  return queryClient.getQueryData<SessionQueryDataForMethod<Method>>(queryKey);
};
